import { UploadFileTypeEnum } from 'api-hooks/upload/upload.model';
import { EnumList } from 'common/constants/enum';
import DeleteIconButton from 'components/common/delete-icon-button';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import EnumSelectInput from 'legacy-modules/master/select-input/enum';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import { CardContainer, DocumentContainer, HalfContainer } from './style';
import GuestSelectInput from '../../select-input';

export default function PassportItemCard(props: {
  idx: number;
  onRemove: (idx: number) => void;
}) {
  const { t } = useTranslation();
  const { idx, onRemove } = props;

  return (
    <CardSection style={{ marginBottom: 16, paddingBottom: 0 }}>
      <CardContainer>
        <DocumentContainer>
          <Text variant="LabelMedium">{`${t('common:document')} ${
            idx + 1
          }`}</Text>
          <Separator gap={16} />
          <GuestSelectInput
            name={`passports.${idx}.guestId`}
            required
            label=""
            hideRequiredStar
            hideLabel
          />
        </DocumentContainer>
        <DeleteIconButton onClick={() => onRemove(idx)} />
      </CardContainer>
      <Separator gap={16} />
      <CardContainer $style={containerStyles}>
        <HalfContainer>
          <EnumSelectInput
            name={`passports.${idx}.type`}
            enumType={EnumList.PassportType}
            label={t('common:type')}
            placeholder={t('common:type')}
            required
          />
        </HalfContainer>
        <Separator gap={16} direction="horizontal" />
        <HalfContainer>
          <Input
            type="text"
            name={`passports.${idx}.number`}
            label={t('common:document_number')}
            placeholder={t('common:document_number')}
            required
          />
        </HalfContainer>
      </CardContainer>
      <CardContainer $style={containerStyles}>
        <HalfContainer>
          <Input
            type="text"
            name={`passports.${idx}.identifierNumber`}
            label={t('common:ktp')}
            placeholder={t('common:ktp')}
            required
          />
        </HalfContainer>
        <Separator gap={16} direction="horizontal" />
        <HalfContainer $style={nationalityStyles}>
          <HalfContainer>
            <Input
              type="text"
              name={`passports.${idx}.nationality`}
              label={t('common:nationality')}
              placeholder={t('common:nationality')}
              required
            />
          </HalfContainer>
          <Separator gap={16} direction="horizontal" />
          <HalfContainer>
            <Input
              type="select"
              options={[
                { id: 'male', label: t('common:male') },
                { id: 'female', label: t('common:female') },
              ]}
              name={`passports.${idx}.gender`}
              label={t('common:gender')}
              placeholder={t('common:gender')}
              required
            />
          </HalfContainer>
        </HalfContainer>
      </CardContainer>
      <CardContainer $style={containerStyles}>
        <HalfContainer>
          <Input
            type="text"
            name={`passports.${idx}.familyName`}
            label={t('common:family_name')}
            placeholder={t('common:family_name')}
            required
          />
        </HalfContainer>
        <Separator gap={16} direction="horizontal" />
        <HalfContainer>
          <Input
            type="text"
            name={`passports.${idx}.givenName`}
            label={t('common:given_name')}
            placeholder={t('common:given_name')}
            required
          />
        </HalfContainer>
      </CardContainer>
      <CardContainer $style={containerStyles}>
        <HalfContainer>
          <Input
            type="text"
            name={`passports.${idx}.placeOfBirth`}
            label={t('common:place_of_birth')}
            placeholder={t('common:place_of_birth')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name={`passports.${idx}.dateOfBirth`}
            label={t('common:date_of_birth')}
            placeholder={t('common:date_of_birth')}
            required
          />
        </HalfContainer>
      </CardContainer>
      <CardContainer $style={containerStyles}>
        <HalfContainer>
          <Input
            type="text"
            name={`passports.${idx}.issueState`}
            label={t('common:issue_state')}
            placeholder={t('common:issue_state')}
            required
          />
        </HalfContainer>
        <Separator gap={16} direction="horizontal" />
        <HalfContainer>
          <Input
            type="date-time"
            name={`passports.${idx}.expiredAt`}
            label={t('common:date_of_expiry')}
            placeholder={t('common:date_of_expiry')}
            required
          />
        </HalfContainer>
      </CardContainer>
      <HalfContainer>
        <Input
          type="files"
          name={`passports.${idx}.files`}
          label={t('common:upload_document')}
          valueKey="file"
          previewKey="url"
          fileType={UploadFileTypeEnum.GuestPassport}
          required
        />
      </HalfContainer>
    </CardSection>
  );
}

const containerStyles: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
  },
};

const nationalityStyles: StyleObject | any = {
  display: 'flex',
  flexDirection: 'column',
  '@media screen and (min-width: 441px)': {
    flexDirection: 'row',
  },
};
